import React from "react";
import { BackgroundImage, TeethLogo, ServiceBottomButton } from "../../Components"
import prosthodontic_dentistry from "../../assets/Images/prosthodontic-dentistry-home.jpg"

const ProsthodonticDentistry = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.prosthodontic_dentistry_heading} text={selectedLanguage?.txt_explore_our_services} mainClass='prosthodontic-dentistry-background' />
            <TeethLogo heading={selectedLanguage?.prosthodontic_dentistry_heading} />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={prosthodontic_dentistry} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>{selectedLanguage?.txt_prosthodontic_dentisty_or_prosthetic_dentistry}</p>
                    <p>{selectedLanguage?.txt_our_dental_center_provides_the_full_range}</p>
                    <p>
                        {selectedLanguage?.txt_due_to_the_major_advancments_in_the_field_of_dental_cermics}
                    </p>
                    <p>{selectedLanguage?.txt_the_benefits_of_fixing_missing_teeth}</p>
                    <ul>
                        <li>{selectedLanguage?.txt_prevents_existing_teth_from_drifting_into_surrounding_space}</li>
                        <li>{selectedLanguage?.txt_teeth_out_of_position}</li>
                        <li>{selectedLanguage?.txt_the_difficult_of_through_cleaning}</li>
                        <li>{selectedLanguage?.txt_improves_out_your_smile}</li>
                        <li>{selectedLanguage?.txt_help_to_Properly_chew_foods}</li>
                        <li>{selectedLanguage?.txt_may_improve_speech}</li>
                        <li>{selectedLanguage?.txt_prevent_a_sagging_face_by_providing}</li>
                    </ul>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default ProsthodonticDentistry